import classes from 'classnames';
import styles from './ProgressBar.module.scss';

export type ProgressBarProps = {
  completeValue?: number;
  progress: number;
  className?: string;
};

export default function ProgressBar({
  completeValue = 1,
  progress,
  className,
}: ProgressBarProps) {
  return (
    <div className={classes(styles.bar, className)}>
      <div
        className={styles.fill}
        style={{ width: `${(progress / completeValue) * 100}%` }}
      />
    </div>
  );
}
